// extracted by mini-css-extract-plugin
module.exports = {"currentUserEmail":"CurrentUserEmail_currentUserEmail__1YfVb","fadein":"CurrentUserEmail_fadein__EtirP"};